import React from "react"

import { Link } from "react-router-dom"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faThumbsUp, faCommentAlt, faCogs, faCheckCircle } from "@fortawesome/free-solid-svg-icons"


class Game extends React.Component{
    constructor(){
        super()
        this.state={
            reviews: null,
            extensionOpen: false,
            openExtension: "",
            deleteHidden: true,
            loadingReview: true
        }
        this.newReviewLimit = 3
    }
    placeHolderImg = (e) =>{
        e.target.src = "/placeHolder.png"
    }
    static parseISOString = (ISOString) =>{
        let date = new Date(ISOString)
        let year = date.getFullYear()
        let month = date.getMonth()+1
        let dt = date.getDate()
        let hour = date.getHours()
        let min = date.getMinutes()
    
        dt = dt >= 10? dt : `0${dt}`;
        month = month >= 10 ? month : `0${month}`;
        hour = hour >= 10 ? hour : `0${hour}`
        min = min >= 10 ? min : `0${min}`
        return `${year}-${month}-${dt} ${hour}:${min}`
    }
    render(){
        const {id, imgUrl, gameName, createdAt, updatedAt, 
            upvoteCount, reviewCount, greenlit } = this.props
        return(
            <div className="game">
                <img onError={this.placeHolderImg} src={imgUrl} className="col" alt={gameName}/>
                <div className="metaContainer">
                    <div className="titleContainer">
                        <h2 className="gameTitle">{gameName}</h2>
                    </div>
                    <div className="meta">
                        <div className="col">
                            <div className="date">
                                Created at: {Game.parseISOString(createdAt)}
                            </div>
                            <div className="date">
                                Last updated at: {Game.parseISOString(updatedAt)}
                            </div>
                            <div className="rating">
                                <div className="likes">
                                    <FontAwesomeIcon icon={faThumbsUp} />{upvoteCount}
                                </div>
                                <div className="comments">
                                    <FontAwesomeIcon icon={faCommentAlt} />{reviewCount}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Link to={`/manage/game/${id}/invite`}>
                        <button className="manageBtn">
                            <FontAwesomeIcon icon={faCogs} />&nbsp;
                            Manage Game
                        </button>
                    </Link>
                </div>
                { greenlit === true
                ? <div className="greenlit">
                    <FontAwesomeIcon icon={faCheckCircle} /> Greenlit for build!
                </div>
                : null }
            </div>
        )
    }
}

export default Game